module.exports = {
      id: "android-block-usage",
      viewBox: "0 0 114 35",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#android-block",
      toString: function () {
        return this.url;
      }
    }